// ** Third Party Components
import { ApolloClient, createHttpLink, InMemoryCache, from } from '@apollo/client'
const { createUploadLink } = require('apollo-upload-client')
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import toast from 'react-hot-toast'
import {ApolloLink} from 'apollo-link'
import PusherLink from './pusher'

const echoLink = new PusherLink()

const httpLink = createUploadLink({
    uri: `${process.env.REACT_APP_API_URL}/graphql`
  })

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = JSON.parse(localStorage.getItem('access_token'))
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ""
      }
    }
  })

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.message === 'Unauthenticated.') {
        localStorage.removeItem('access_token')
        localStorage.removeItem('userData')
        localStorage.removeItem('userAbilities')
        window.location.href = '/login'
      }
     
    }
  }

  if (networkError) toast.error(`[Network error]: ${networkError}`)
})
const client = new ApolloClient({
    //link: errorLink.concat(authLink.concat(httpLink)),
    link: ApolloLink.from([echoLink, errorLink, authLink, httpLink]),
    cache: new InMemoryCache()
})

export default client
